import { AuthApi, OmitTypeClass } from "@freeplay/shared-code";

export class AuthAPIWrapper {
    private ready: Promise<boolean>;
    private readyResolve!: (value: boolean) => void;

    private api!: AuthApi;
    private token!: string;
    private tenantSlug!: string;

    constructor() {
        this.ready = new Promise((resolve) => {
            this.readyResolve = resolve;
        });
    }

    public init(api: AuthApi, token: string, tenantSlug: string): void {
        this.api = api;
        this.token = token;
        this.tenantSlug = tenantSlug;
        this.readyResolve(true);
    }

    public clearUser(): void {
        this.token = "";
    }

    public async loginUser(): Promise<OmitTypeClass> {
        await this.ready;
        return await this.api.authControllerLogin(this.tenantSlug, this.getOptions());
    }

    private getOptions() {
        return {
            headers: {
                Authorization: `Bearer ${this.token}`,
            },
        };
    }
}
